module.exports = __webpack_public_path__ + "img/kubernetes.47cd35b3.png";